<template>
  <div ref="outer">
    <component :is="formRowComponent" v-if="showIntro">
      <h2 v-if="content.heading" class="mb-0">
        {{ content.heading }}
      </h2>
      <p v-if="content.intro" class="intro mt-2 mb-0">
        {{ content.intro }}
      </p>
    </component>

    <component :is="formRowComponent" class="field-row">
      <div class="form-field">
        <slot />
      </div>

      <field-help v-if="content.help" :text="content.help" class="field-help" />

      <template v-if="showGetHelp" #right-column>
        <slot name="request-help-prompt" />
      </template>
    </component>
  </div>
</template>

<script>
import FieldHelp from './field-help'
import FormRow from './form-row'
import isPresent from '../helpers/is-present'

export default {
  components: { FieldHelp, FormRow },
  props: {
    content: {
      type: Object,
      required: true
    },
    formRowComponent: {
      type: Object,
      required: false,
      default() { return FormRow }
    },
    showGetHelp: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      showIntro: isPresent(this.content.heading) || isPresent(this.content.intro)
    }
  },

  methods: {
    scrollIntoView() {
      this.$refs.outer.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }
}
</script>

<style lang="scss" scoped>
@use "~common_styles/breakpoints" as breakpoints;

p.intro {
  font-size: 20px;
  line-height: 1.4;
  @include breakpoints.screen-mobile-only {
    font-size: 16px;
  }
}
.field-row {
  margin-top: 30px;
  @include breakpoints.screen-mobile-only {
    margin-top: 20px;
  }
}
.form-field {
  margin-bottom: 20px;

  ::v-deep(:not(.trix-dialog)) { // Don't apply to fields within the Trix editor (e.g.: link dialog)
    ::v-deep(input:not([type=radio])), ::v-deep(select), ::v-deep(textarea) {
      padding: 13px 15px;
      font-size: 1.25rem;
      margin-bottom: 20px;
    }
  }


  ::v-deep(input[type=text]), ::v-deep(input:not([type])), ::v-deep(select) {
    height: 58px;

    @include breakpoints.screen-mobile-only {
      height: 50px;
    }
  }
}

.field-help {
  margin-bottom: 0;
}
</style>
